const earnStatusKeys = [
  "pointEarnStatus",
  "pointsEarnStatus",
  "PointEarnStatus",
  "PointsEarnStatus",
  "pointEarnStaus",
  "pointsEarnStaus",
  "PointEarnStaus",
  "PointsEarnStaus",
];

const redeemStatusKeys = [
  "pointsRedeemStatus",
  "pointRedeemStatus",
  "PointsRedeemStatus",
  "PointRedeemStatus",
];

const getStatus = (sources, keys) => {
  for (const source of sources) {
    if (!source || typeof source !== "object") continue;

    for (const key of keys) {
      const value = source[key];
      if (value !== undefined && value !== null && String(value).trim() !== "") {
        return value;
      }
    }

    const nestedResponse = source.response;
    if (nestedResponse && typeof nestedResponse === "object") {
      for (const key of keys) {
        const value = nestedResponse[key];
        if (value !== undefined && value !== null && String(value).trim() !== "") {
          return value;
        }
      }
    }
  }

  return undefined;
};

export const getPointEarnStatus = (...sources) =>
  getStatus(sources, earnStatusKeys);

export const getPointsRedeemStatus = (...sources) =>
  getStatus(sources, redeemStatusKeys);

export const isRewardStatusNotApplicable = (status) => {
  if (status === undefined || status === null) return false;

  const normalizedStatus = String(status)
    .trim()
    .toLowerCase()
    .replace(/[^a-z]/g, "");

  return normalizedStatus === "na" || normalizedStatus === "notapplicable";
};
